var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 77,
    viewBox: "0 0 90 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enhanced precision-01",
    clipPath: "url(#clip0_887_4691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M76.0998 38.9996V24.8996M63.3998 24.8996V38.9996M56.9998 1.09961V19.7996C56.9998 22.3996 59.0998 24.5996 61.7998 24.5996H77.5998C80.1998 24.5996 82.3998 22.4996 82.3998 19.7996V1.09961M69.8998 69.6996V75.8996M70.7998 51.7996H79.6998M33.3998 3.79961C22.5998 7.49961 13.9998 15.9996 10.2998 26.7996M10.2998 50.0996C13.9998 60.8996 22.4998 69.5996 33.2998 73.2996M82.3998 49.9996V43.7996C82.3998 41.1996 80.2998 38.9996 77.5998 38.9996H61.7998C59.1998 38.9996 56.9998 41.0996 56.9998 43.7996V49.9996C56.9998 53.1996 58.1998 56.2996 60.3998 58.6996L68.8998 67.6996H70.4998L78.9998 58.6996C81.1998 56.2996 82.3998 53.1996 82.3998 49.9996Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45 66.1C44.2 66.1 43.3 66.1 42.5 66",
    stroke: "#F69A4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.7999 65.2008C25.9999 62.0008 17.3999 51.3008 17.3999 38.5008C17.3999 24.9008 27.1999 13.6008 40.0999 11.3008",
    stroke: "#F69A4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.81 4.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M42.5 11.0004C43.3 10.9004 44.2 10.9004 45 10.9004",
    stroke: "#F69A4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_887_4691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 77,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon03.5e8d00c666d7ec82393e5c8d7d96c243.svg";
export { ForwardRef as ReactComponent };